import { defineStore } from 'pinia'
import router, { constantRouterMap, resetRouter, homeRoute, colaPageRoute } from '@/router'
import { generateRoutesByServer, flatMultiLevelRoutes, Layout } from '@/utils/routerHelper'
import { store } from '../index'
import { cloneDeep } from 'lodash-es'
import { getRolePermission, getRoleModelPermission } from '@/api'

export interface PermissionState {
  routers: AppRouteRecordRaw[]
  addRouters: AppRouteRecordRaw[]
  isAddRouters: boolean
  menuTabRouters: AppRouteRecordRaw[]
  currentPermission: []
  currentEntryCode: string
}

export const usePermissionStore = defineStore('permission', {
  state: (): PermissionState => ({
    routers: [],
    addRouters: [],
    isAddRouters: false,
    menuTabRouters: [],
    currentPermission: [],
    currentEntryCode: ''
  }),
  getters: {
    getRouters(): AppRouteRecordRaw[] {
      return this.routers
    },
    getAddRouters(): AppRouteRecordRaw[] {
      return flatMultiLevelRoutes(cloneDeep(this.addRouters))
    },
    getIsAddRouters(): boolean {
      return this.isAddRouters
    },
    getMenuTabRouters(): AppRouteRecordRaw[] {
      return this.menuTabRouters
    },
    btnPermission(): object {
      const obj: any = {}
      this.currentPermission.forEach((btn) => {
        obj[btn.name] = true
      })
      return obj
    },
    getCurrentEntryCode(): string {
      return this.currentEntryCode
    }
  },
  actions: {
    // 从后端获取路由
    async fetchRoutesData() {
      const mainTreeRes = await getRolePermission()
      // const [mainTreeRes, modelTreeRes] = await Promise.all([
      //   getRolePermission(),
      //   getRoleModelPermission()
      // ])
      const mainTree = mainTreeRes.data
      // const modelTree = modelTreeRes.data
      // const modelRootIndex = mainTree?.children.findIndex((item: any) => item.name === 'MasterData')
      // let modelRoot = null
      // if (modelRootIndex > -1) {
      //   modelRoot = mainTree.children[modelRootIndex]
      //   modelRoot.children = modelTree
      // }
      return mainTree?.children || []
    },
    generateRoutes(
      type: 'server' | 'frontEnd' | 'static',
      routers?: AppCustomRouteRecordRaw[] | string[]
    ): Promise<unknown> {
      return new Promise<AppRouteRecordRaw[]>((resolve) => {
        let routerMap: AppRouteRecordRaw[] = []
        routerMap = generateRoutesByServer(routers as AppCustomRouteRecordRaw[])
        // 添加首页路由
        routerMap.unshift(homeRoute)
        // routerMap.push(colaPageRoute)
        // 动态路由，404一定要放到最后面
        this.addRouters = routerMap.concat([
          {
            path: '/common',
            name: 'Common',
            component: Layout,
            meta: {
              hidden: true
            },
            children: [
              {
                path: 'account/detail',
                component: () => import('@/views/User/Account/detail.vue'),
                name: 'UserInfo',
                meta: {
                  hidden: true,
                  title: '个人信息',
                  noTagsView: true
                }
              }
            ]
          },
          {
            path: '/:path(.*)*',
            redirect: '/404',
            name: '404Page',
            meta: {
              hidden: true,
              breadcrumb: false
            }
          }
        ])

        // 渲染菜单的所有路由
        this.routers = cloneDeep(constantRouterMap).concat(routerMap)
        this.setMenuTabRouters(routerMap)
        resolve(routerMap)
        // window.initWm && window.initWm()
      })
    },
    resetRoutes(): void {
      resetRouter()
      this.generateRoutes('server', [])
      this.addRouters.forEach((route) => router.addRoute(route as unknown as RouteRecordRaw))
    },
    setIsAddRouters(state: boolean): void {
      this.isAddRouters = state
    },
    setMenuTabRouters(routers: AppRouteRecordRaw[]): void {
      this.menuTabRouters = routers
    },
    setCurrentPermission(route: AppRouteRecordRaw): void {
      this.currentPermission = route?.meta?.button || []
    },
    setCurrentEntryCode(route: AppRouteRecordRaw): void {
      this.currentEntryCode = route?.meta?.resourceCode
    }
  },
  persist: {
    paths: ['routers', 'addRouters', 'menuTabRouters']
  }
})

export const usePermissionStoreWithOut = () => {
  return usePermissionStore(store)
}
